export enum OwnListSearchType {
    Repairtime = 1,
    List = 2,
}
